<template>
  <input type="text" class="form-control" :id="name" :name="name">
</template>
<script>
  import { isObject, isEqual } from 'lodash'
  import $ from 'jquery'
  import moment from 'moment'
  import 'bootstrap-daterangepicker'

  export default {
    props: {
      value: {
        required: false
      },
      name: {
        required: true,
        type: String
      },
      singleDatePicker: {
        type: Boolean,
        default: false
      },
      maxDate: {
        required: false,
        default: null
      },
      minDate: {
        required: false,
        default: null
      },
      opens: {
        type: String,
        default: 'left'
      },
      drops: {
        type: String,
        default: 'down'
      },
      locale: {
        type: Object,
        default () {
          return {
            format: 'DD/MM/YYYY',
            cancelLabel: 'Clear'
          }
        }
      }
    },

    computed: {
      startDate () {
        if (isObject(this.value)) {
          return this.value.from
        } else {
          return this.value
        }
      },
      endDate () {
        if (isObject(this.value)) {
          return this.value.to
        } else {
          return this.value
        }
      }
    },

    watch: {
      value (newValue, oldValue) {
        if (isEqual(newValue, oldValue)) {
          return
        }

        if (this.startDate === null && this.endDate === null) {
          $(this.$el).val('')

          return
        }

        let picker = $(this.$el).data('daterangepicker')

        picker.setStartDate(this.startDate)
        picker.setEndDate(this.endDate)

        $(this.$el).trigger('apply.daterangepicker', picker)
      },

      minDate (value) {
        let picker = $(this.$el).data('daterangepicker')

        picker.minDate = value
      },

      maxDate (value) {
        let picker = $(this.$el).data('daterangepicker')

        picker.maxDate = value
      }
    },

    mounted () {
      $(this.$el).addClass('pickdaterange').daterangepicker({
        showDropdowns: true,
        maxDate: this.maxDate,
        minDate: this.minDate,
        ranges: {
          'Today': [
            moment().startOf('day'),
            moment().endOf('day')
          ],
          'Yesterday': [
            moment().startOf('day').subtract(1, 'day'),
            moment().endOf('day').subtract(1, 'day')
          ],
          'Last 7 Days': [
            moment().startOf('day').subtract(7, 'days'),
            moment().endOf('day')
          ],
          'Last 30 Days': [
            moment().startOf('day').subtract(30, 'days'),
            moment().endOf('day')
          ],
          'This Month': [
            moment().startOf('month'),
            moment().endOf('month')
          ],
          'Last Month': [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month')
          ]
        },
        alwaysShowCalendars: true,
        singleDatePicker: this.singleDatePicker,
        opens: this.opens,
        drops: this.drops,
        locale: this.locale,
        autoUpdateInput: this.startDate !== null && this.endDate !== null
      })

      if (this.startDate) {
        $(this.$el).data('daterangepicker').setStartDate(this.startDate)
      }

      if (this.endDate) {
        $(this.$el).data('daterangepicker').setEndDate(this.endDate)
      }

      $(this.$el).on('apply.daterangepicker', (event, picker) => {
        if (this.singleDatePicker) {
          $(event.target).val(`${picker.startDate.format(picker.locale.format)}`).trigger('change')
        } else {
          $(event.target).val(`${picker.startDate.format(picker.locale.format)} - ${picker.endDate.format(picker.locale.format)}`).trigger('change')
        }
      }).on('cancel.daterangepicker', (event, picker) => {
        if (this.singleDatePicker) {
          this.$emit('input', null)
        } else {
          this.$emit('input', { from: null, to: null })
        }

        $(event.target).val(null)
      }).on('change', ({ target }) => {
        let picker = $(target).data('daterangepicker')

        if (this.singleDatePicker) {
          this.$emit('input', picker.startDate.format(picker.locale.format))
        } else {
          this.$emit('input', { from: picker.startDate.format(picker.locale.format), to: picker.endDate.format(picker.locale.format) })
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// DateRange.vue?3633f36e